var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDropDownSvgrepoCom1({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 38,
    viewBox: "0 0 38 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "drop-down-svgrepo-com 1",
    clipPath: "url(#clip0_66_152)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.47847 19L17.0933 10.3852L18.6736 11.9678L12.7568 17.8823L29.0588 17.8823V20.1177L12.7568 20.1177L18.6736 26.0322L17.0933 27.6148L8.47847 19ZM38 19C38 8.52318 29.4768 0 19 0C8.52318 0 0 8.52318 0 19C0 29.4768 8.52318 38 19 38C29.4768 38 38 29.4768 38 19Z",
    fill: "url(#paint0_linear_66_152)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_66_152",
    x1: 3,
    y1: 4,
    x2: 38,
    y2: 38,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFA34F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF7A00"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_66_152"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 38,
    height: 38,
    fill: "white",
    transform: "matrix(0 1 -1 0 38 0)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDropDownSvgrepoCom1);
export default __webpack_public_path__ + "static/media/drop-down-svgrepo-com 1.76b8b2e4dfe45c06247c1116b792a99f.svg";
export { ForwardRef as ReactComponent };